import type { Conference } from "../../api.js";
import { WebsiteWorkspacePreview } from "../../workspaces/WebsiteWorkspacePreview.js";
import { DocumentsExportsCenter } from "../publish/DocumentsExportsCenter.js";
import { StageHeader } from "./StageScaffold.js";

export function PublishStage({ conference }: { conference: Conference }) {
  return <div className="conference-stage"><StageHeader title="Publish" description="Prepare conference documents and the public website, then release each surface deliberately." /><DocumentsExportsCenter conference={conference} /><WebsiteWorkspacePreview conference={conference} /></div>;
}
